module.exports = __webpack_public_path__ + "media/front_movie_02.54599615.mp4";